<div class="forgot-password overlay" *ngIf="this._UiHelper.forgotPass">
  <div class="modal-inside">
    <div class="modal-close d-flex p-2">
      <div class="empty-space"></div>
      <div class="title my-auto forgot-pass-title">
        {{ 'Forgot_Password' | translate }}
      </div>
      <div class="close-modal d-flex ml-auto">
        <div class="cls mx-auto" (click)="this._UiHelper.toogleForgotPass()">✕</div>
      </div>
    </div>
    <span class="forgot-text">{{ 'Enter_email_address_request_password_and_use_new_password_from_the_email' | translate }}</span>
    <form class="forgot-form" [formGroup]="forgotPasswordDatas">
      <inputBase
        formControlName="email"
        [fID]="'email'"
        fErrorText="{{ 'Please_enter_a_valid_mail_address' | translate }}"
        fPlaceholder="Email"
        fInputType="text"
        extraClass="forgotPass"></inputBase>
      <div class="date-container" style="padding-left: 30px; padding-top: 20px; width: 100%; padding-right: 30px">
        <div class="form-b3 form-field-b3 birthDayForm">
          <datepickerb3 formControlName="birthDay" [fID]="'start'" fPlaceholder="{{ 'DateOfBirth' | translate }}"> </datepickerb3>
        </div>
      </div>
      <div
        class="btn colored login-dropdown-btn"
        style="margin-top: 20px; min-height: 36px !important"
        *ngIf="forgotPasswordDatas.valid; else noValid"
        (click)="submitForgotPasswordData2()">
        <div class="login-button-text">{{ 'Confirm' | translate }}</div>
      </div>
      <ng-template #noValid>
        <div class="btn colored login-dropdown-btn" style="opacity: 0.5; margin-top: 20px; min-height: 36px !important">
          <div class="login-button-text">{{ 'Confirm' | translate }}</div>
        </div>
      </ng-template>
    </form>
  </div>
</div>
